/*
 * TSS Quiz Result PDP, renderer
 * ------------------------------------------------------------
 * Reads session from localStorage, fetches live Shopify product data,
 * populates all modules on /pages/your-routine.
 *
 * Depends on: window.TSSQuizEngine (tss-quiz-personas.js)
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'tss_quiz_session_v1';
  var COMPLETE_COOKIE = 'tss_quiz_complete';

  var LABELS = {
    skin: { oily: 'Oily', dry: 'Dry', combination: 'Combination', normal: 'Normal', not_sure: 'Not sure (→ Combination)' },
    freq: { persistent: 'Persistent', periodic: 'Periodic', rare: 'Rare' },
    makeup: { yes_daily: 'Daily', sometimes: 'Sometimes', no_rarely: 'No / Rarely' }
  };


  // Unified event emitter. Fires a CustomEvent on document AND a gtag event
  // if GA4 is loaded. All PDP interactions flow through this so a single
  // analytics subscriber (future Supabase writer) can capture everything.
  function track(name, props) {
    try {
      document.dispatchEvent(new CustomEvent('tss-quiz:' + name, { detail: props || {} }));
    } catch (e) {}
    if (window.gtag) {
      try { window.gtag('event', 'tss_quiz_' + name, props || {}); } catch (e) {}
    }
  }

  function init() {
    var state = loadState();
    console.log('[TSS Quiz] PDP init. State:', state);
    if (!state || !state.completed || !state.persona) {
      console.warn('[TSS Quiz] No completed state found. Showing empty state.');
      show('tss-result-empty');
      hide('tss-result-loading');
      hide('tss-result-content');
      return;
    }
    setCookie(COMPLETE_COOKIE, '1', 30); // refresh cookie

    // Ask the AI module for personalised copy. It returns a Promise that
    // always resolves, even if the backend is down / not configured. Until
    // it resolves, we can't render product cards (they need AI short/deep copy).
    // The promise resolves instantly if cached, so there's no perceived delay
    // in the quiz→PDP flow.
    var aiPromise = (window.TSSQuizAI && typeof window.TSSQuizAI.generate === 'function')
      ? window.TSSQuizAI.generate(state)
      : Promise.resolve(null);

    aiPromise.then(function (aiCopy) {
      console.log('[TSS Quiz] AI copy resolved. source:', (aiCopy && aiCopy.source) || 'none');
      try {
        renderPage(state, aiCopy);
      } catch (e) {
        console.error('[TSS Quiz] renderPage failed:', e);
        show('tss-result-content');
        hide('tss-result-loading');
      }
      track('pdp_view', {
        session_id: state.session_id,
        persona_id: state.persona.persona_id,
        ai_source: (aiCopy && aiCopy.source) || 'none',
        // v2 photo dimensions, so pdp_view stays the one top-of-funnel event
        photo_used: !!(state.answers && state.answers.photo_read),
        vision_added: (state.answers && state.answers.vision_changes &&
                       (state.answers.vision_changes.added || []).join(',')) || ''
      });
      // Bottom reviews grid was removed in favour of a Judge.me section below our content.
    });
  }

  // =========================================================================
  // Reviews reveal, data is server-side rendered from Judge.me metafields
  // (product.metafields.reviews.rating + rating_count). No async widgets.
  // JS just adds .tss-reviews-active to the 3 cards matching the user's persona.
  // =========================================================================
  var REVIEW_PRODUCT_CODES = ['RCF','BSC','USDC','SFARS','BRGM','BRIM'];

  function renderJudgeMeReviews(persona) {
    var grid = document.getElementById('tss-reviews-grid');
    var empty = document.getElementById('tss-reviews-empty');
    if (!grid) return;

    var productsForReviews = (persona.product_meta || []).filter(function (p) {
      return REVIEW_PRODUCT_CODES.indexOf(p.code) !== -1;
    }).slice(0, 3);

    if (!productsForReviews.length) {
      if (empty) empty.style.display = 'block';
      return;
    }

    var handlesToShow = productsForReviews.map(function (p) { return p.handle; });
    var revealed = 0;
    grid.querySelectorAll('.tss-reviews-block--ssr').forEach(function (block) {
      var h = block.getAttribute('data-tss-review-handle');
      if (handlesToShow.indexOf(h) !== -1) {
        block.classList.add('tss-reviews-active');
        revealed++;
      }
    });
    console.log('[TSS Quiz] Revealed', revealed, 'review cards for handles:', handlesToShow);
  }

  function loadState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); } catch (e) { return null; }
  }

  function show(id) { var el = document.getElementById(id); if (el) el.style.display = 'block'; }
  function hide(id) { var el = document.getElementById(id); if (el) el.style.display = 'none'; }
  function setText(id, t) { var el = document.getElementById(id); if (el) el.textContent = t || ''; }
  function setCookie(name, value, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function renderPage(state, aiCopy) {
    hide('tss-result-empty');
    show('tss-result-content');

    var p = state.persona;
    var a = state.answers;

    // Each wrapped in try/catch so a copy-shape issue in one block can't hide the whole page.
    // v2. Individually try/caught on purpose: an unguarded throw here would
    // skip everything below it, including the products.
    try { renderFindings(p, a, state); } catch (e) { console.error('[TSS Quiz] findings render failed:', e); }
    try { renderPhotoReoffer(state); } catch (e) { console.error('[TSS Quiz] photo re-offer render failed:', e); }
    try { renderAcknowledgement(p, a, aiCopy, state); } catch (e) { console.error('[TSS Quiz] acknowledgement render failed:', e); }
    try { renderJobsPlan(p, state); }                  catch (e) { console.error('[TSS Quiz] plan render failed:', e); }

    // Edit answers
    var editBtn = document.getElementById('tss-edit-answers');
    if (editBtn) editBtn.onclick = function () {
      state.completed = false;
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch(e){}
      document.cookie = COMPLETE_COOKIE + '=; Max-Age=0; path=/';
      window.location.href = '/';
      setTimeout(function () { if (window.TSSQuiz) window.TSSQuiz.open('edit'); }, 300);
    };

    // AM/PM routine steps (Section 4)
    renderRoutine('tss-am-steps', p.am, p);
    renderRoutine('tss-pm-steps', p.pm, p);
    setText('tss-intro-delay', p.intro_delay || '');

    // Timeline (bundle-aware: with or without RCF)
    renderTimeline(p);

    // Barrier-first disclaimer, rendered only for barrier_first personas
    // (irritation flagged alongside a treatable concern). Sits between the
    // intro_delay text and the post-purchase note.
    renderBarrierFirst(p);

    // Post-purchase support note. Single occurrence on the page, lives just
    // below the AM/PM routine (was previously duplicated across sections).
    var ppNote = document.getElementById('tss-postpurchase-note');
    if (ppNote && window.TSSQuizCopy && window.TSSQuizCopy.output) {
      ppNote.innerHTML = '<strong>Post-purchase support.</strong> ' + escapeHtml(window.TSSQuizCopy.output.post_purchase_note || '');
    }

    renderFAQ(p);

    // Fetch products + render grouped cards (Section 3)
    fetchAndRenderGroupedProducts(p, state, aiCopy);

    hide('tss-result-loading');
  }

  // =========================================================================
  // Acknowledgement: picks a template keyed by the user's dominant concern story,
  // fills {skin} / {freqPhrase} from their answers. Absorbs the old profile card.
  // =========================================================================
  var SKIN_WORDS = { oily: 'oily', dry: 'dry', combination: 'combination', normal: 'normal', not_sure: 'combination' };
  var FREQ_PHRASES = {
    persistent: ', almost every day',
    frequent:   ', in waves every few weeks',
    periodic:   ', around your cycle',
    rare:       ', only occasionally'
  };

  function pickAckKey(buckets) {
    if (buckets.fungal_acne) return 'fungal';
    if (buckets.rosacea)     return 'rosacea';
    if (buckets.irritation)  return 'irritation';
    if (buckets.active_acne && buckets.marks)   return 'marks_acne';
    if (buckets.active_acne && buckets.texture) return 'texture_acne';
    if (buckets.active_acne) return 'active_acne';
    if (buckets.marks)       return 'marks';
    if (buckets.texture)     return 'texture';
    return 'maintenance';
  }

  function renderAcknowledgement(persona, answers, aiCopy, state) {
    if (!window.TSSQuizCopy || !window.TSSQuizCopy.output || !window.TSSQuizCopy.output.acknowledgement) return;
    var ack = window.TSSQuizCopy.output.acknowledgement;

    // Prefer AI-generated headline; fall back to keyed template.
    var source = 'template';
    var body;
    if (aiCopy && typeof aiCopy.ack === 'string' && aiCopy.ack.trim()) {
      body = aiCopy.ack.trim();
      source = aiCopy.source || 'api';
    } else {
      var buckets = persona.buckets || {};
      var key = pickAckKey(buckets);
      var tpl = (ack.templates && ack.templates[key]) || ack.templates.maintenance;
      var skinWord = SKIN_WORDS[answers.skin_type] || 'your';
      var freqPhrase = FREQ_PHRASES[persona.freq] || '';
      body = tpl.replace('{skin}', skinWord).replace('{freqPhrase}', freqPhrase);
    }

    setText('tss-ack-eyebrow', ack.eyebrow || 'Here\'s what we\'re working with');
    setText('tss-ack-heading', body);

    track('ack_shown', {
      session_id: state && state.session_id,
      persona_id: persona && persona.persona_id,
      source: source
    });

    // Labelled answer chips so the user can see at a glance what we captured.
    // Each chip: small muted label + value, separated with a dot.
    var chipHtml = [];
    if (answers.skin_type) {
      chipHtml.push(chip('Skin', cap(SKIN_WORDS[answers.skin_type] || answers.skin_type)));
    }
    // On the photo check card, breakouts is a plain Yes/No and is stored as
    // the generic acne value. Calling that "Small pimples" would be wrong for
    // someone whose photo showed quite a lot, so name the bucket instead.
    var fromCard = answers.photo_source === 'confirmed' || answers.photo_source === 'edited';
    var concernLabels = (answers.concerns || []).map(function (c) {
      if (fromCard && c === 'small_white_red_pimples') return 'Active breakouts';
      return humanize(c);
    }).filter(Boolean);
    if (concernLabels.length) {
      chipHtml.push(chip('Concerns', concernLabels.slice(0, 3).join(', ')));
    }
    if (persona.freq) {
      chipHtml.push(chip('Breakout frequency', humanizeFreq(freqRaw(persona.freq))));
    }
    var triggerLabel = humanizeTriggers(answers.triggers);
    if (triggerLabel) {
      chipHtml.push(chip('Triggers', triggerLabel));
    }
    var sensitivityLabel = humanizeSensitivity(answers.sensitivity);
    if (sensitivityLabel) {
      chipHtml.push(chip('Sensitivity', sensitivityLabel));
    }
    var chipEl = document.getElementById('tss-ack-chips');
    if (chipEl) chipEl.innerHTML = chipHtml.join('<span class="tss-ack__chipsep">·</span>');
  }

  // Triggers can contain multiple values; show a short summary phrase, not a list.
  // Priority order mirrors what we most want the user to see acknowledged.
  function humanizeTriggers(triggers) {
    if (!triggers || !triggers.length) return '';
    var set = {};
    triggers.forEach(function (t) { set[t] = true; });
    var parts = [];
    if (set.hormonal_history || set.hormonal_recent) parts.push('Hormonal');
    if (set.lifestyle)  parts.push('Stress/sleep/diet');
    if (set.environment) parts.push('Sweat/heat/pollution');
    // If the user only said "not_sure", skip the chip entirely; no signal.
    if (!parts.length) return '';
    return parts.slice(0, 2).join(', ');
  }

  function humanizeSensitivity(s) {
    if (!s) return '';
    if (s === 'very')  return 'Reacts often';
    if (s === 'a_bit') return 'Sometimes reactive';
    // "not" (rarely reacts) is the default / least informative, skip the chip.
    return '';
  }

  // Labelled chip, small uppercase label above the value, inline on wider screens.
  function chip(label, value) {
    return '<span class="tss-ack__chip">' +
             '<span class="tss-ack__chip-label">' + escapeHtml(label) + '</span>' +
             '<span class="tss-ack__chip-value">' + escapeHtml(value) + '</span>' +
           '</span>';
  }

  // Reverse-map internal freq bucket back to a user-facing phrase
  function freqRaw(bucket) {
    var m = { persistent: 'almost_always', frequent: 'every_now_then', periodic: 'once_a_month', rare: 'rarely' };
    return m[bucket] || bucket;
  }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

  // =========================================================================
  // Jobs-based Plan (Section 2). Renders 2-4 "jobs" this routine does for
  // the user, the multi-active intro note, and the universal post-purchase promise.
  // =========================================================================
  function renderJobsPlan(persona, state) {
    if (!window.TSSQuizCopy || !window.TSSQuizCopy.output) return;
    var copy = window.TSSQuizCopy.output.jobs_section || {};
    var jobs = (window.TSSQuizEngine && window.TSSQuizEngine.buildJobs)
      ? window.TSSQuizEngine.buildJobs(persona)
      : [];

    setText('tss-plan-eyebrow', copy.eyebrow || 'Your plan');

    var heading = (jobs.length === 1)
      ? (copy.heading_one || 'One thing this routine does for you')
      : (copy.heading_multi || '{count} things this routine does for you').replace('{count}', jobs.length);
    setText('tss-plan-heading', heading);

    // Job list: dot + label per line
    var list = document.getElementById('tss-jobs-list');
    if (list) {
      list.innerHTML = jobs.map(function (j) {
        return '<li class="tss-job">' +
                 '<span class="tss-job__dot" style="background:' + escapeHtml(j.dot) + ';"></span>' +
                 '<span class="tss-job__label">' + escapeHtml(j.label) + '</span>' +
               '</li>';
      }).join('');
    }

    // Intro note, only for multi-active personas
    var intro = document.getElementById('tss-plan-intro');
    if (intro) {
      if ((persona.active_count || 0) >= 2 && copy.intro_multi_active) {
        intro.textContent = copy.intro_multi_active;
        intro.hidden = false;
      } else {
        intro.hidden = true;
      }
    }

    // Post-purchase promise was previously rendered here (#tss-plan-promise).
    // It has been consolidated into the single #tss-postpurchase-note below the
    // AM/PM routine to avoid the same message appearing twice on the page.
    // setText() is a no-op on a missing id, so this is left as a guarded write
    // in case the markup is ever restored.
    var hasRCF = (persona.products || []).indexOf('RCF') !== -1;
    var promiseText = hasRCF
      ? (copy.promise_with_rcf    || copy.promise || '')
      : (copy.promise_without_rcf || copy.promise || '');
    if (document.getElementById('tss-plan-promise')) {
      setText('tss-plan-promise', promiseText);
    }

    track('plan_shown', {
      session_id: state && state.session_id,
      persona_id: persona && persona.persona_id,
      jobs: jobs.map(function (j) { return j.id; }),
      multi_active: (persona.active_count || 0) >= 2
    });
  }

  // =========================================================================
  // Barrier-first disclaimer. Only renders when persona.barrier_first is true,
  // which the engine sets when irritation is flagged alongside a treatable
  // concern (active acne, texture, or marks). Tells the user to run only
  // BSC + moisturiser for the first 2 weeks, then introduce actives slowly.
  // =========================================================================
  function renderBarrierFirst(persona) {
    var host = document.getElementById('tss-barrier-first');
    if (!host) return;
    if (!persona || !persona.barrier_first) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }
    var copy = (window.TSSQuizCopy && window.TSSQuizCopy.output && window.TSSQuizCopy.output.barrier_first) || null;
    if (!copy) { host.hidden = true; return; }
    host.innerHTML =
      '<span class="tss-barrier-first__eyebrow">' + escapeHtml(copy.eyebrow || '') + '</span>' +
      '<h4 class="tss-barrier-first__heading">' + escapeHtml(copy.heading || '') + '</h4>' +
      '<p class="tss-barrier-first__body">' + escapeHtml(copy.body || '') + '</p>';
    host.hidden = false;
  }

  // =========================================================================
  // "What we can see" (v2). Renders only when a photo was read successfully.
  // Never a score, never a grade, never a concern they did not come here for.
  // Renders synchronously from renderPage so it is present when the loading
  // screen lifts, unlike the add-on cards which paint later.
  // =========================================================================
  // "left_cheek" -> "Left cheek". The Worker returns snake_case zone names.
  function zoneLabel(z) {
    var t = String(z || '').replace(/_/g, ' ');
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : '';
  }

  function renderFindings(persona, answers, state) {
    var host = document.getElementById('tss-findings');
    if (!host) return;

    var read = answers && answers.photo_read;
    var copy = (window.TSSQuizCopy && window.TSSQuizCopy.output &&
                window.TSSQuizCopy.output.findings) || null;

    if (!read || read.usable !== true || !copy) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }

    // With side photos too, every "the photo" / "your photo" line on this
    // card reads as plural. "One photo is one day" is left alone on purpose.
    var usedViews = ((read.views || []).filter(function (v) { return v && v.used; })).length;
    if (usedViews > 1) {
      copy = JSON.parse(JSON.stringify(copy), function (k, v) {
        return (typeof v === 'string')
          ? v.replace(/\b([Tt]he|[Yy]our) photo\b/g, '$1 photos')
          : v;
      });
    }

    var changes = (answers.vision_changes) || { added: [], removed: [], skin_type_set: null };
    var zones = read.zones || [];
    var parts = [];

    // Nothing worth a card: no zones, no notes, nothing applied, nothing to
    // flag. This is what a thin read looks like. No block beats an empty one.
    var src0 = answers.photo_source || '';
    if (!zones.length && !read.notes_for_copy && !read.refer_to_human &&
        src0 !== 'diverted' && src0 !== 'confirmed' && src0 !== 'edited' &&
        !((changes && changes.added) || []).length) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }

    parts.push('<span class="tss-findings__eyebrow">' + escapeHtml(copy.eyebrow || '') + '</span>');
    // "From your 3 photos" when the side views were used too.
    var heading = (usedViews > 1 && copy.heading_multi)
      ? copy.heading_multi.replace('{n}', usedViews)
      : (copy.heading || '');
    parts.push('<h3 class="tss-findings__heading">' + escapeHtml(heading) + '</h3>');
    parts.push('<div class="tss-findings__card">');

    // Their own photo, from this browser's localStorage only. Absent is fine.
    var thumb = null;
    try {
      thumb = window.TSSQuizVision
        ? window.TSSQuizVision.loadThumb(state && state.session_id)
        : null;
    } catch (e) { thumb = null; }

    parts.push('<div class="tss-findings__top">');
    if (thumb) {
      parts.push('<img class="tss-findings__photo" src="' + escapeHtml(thumb) + '" alt="">');
    }
    parts.push('<ul class="tss-findings__list">');
    if (zones.length) {
      for (var i = 0; i < zones.length; i++) {
        var z = zones[i] || {};
        var clear = (z.severity === 'clear');
        parts.push(
          '<li class="tss-findings__item' + (clear ? ' tss-findings__item--clear' : '') + '">' +
            '<span><span class="tss-findings__zone">' +
              escapeHtml(zoneLabel(z.zone)) +
            '</span> ' + escapeHtml(z.observation || '') + '</span>' +
          '</li>'
        );
      }
    } else if (read.notes_for_copy) {
      parts.push('<li class="tss-findings__item"><span>' +
        escapeHtml(read.notes_for_copy) + '</span></li>');
    }
    // No zones and no notes means nothing to show. Render no bullet at all
    // rather than an empty coloured dot.
    parts.push('</ul>');
    parts.push('</div>');

    // Three different stories, and the block must tell the right one:
    //   confirmed  photo-first, they said "Looks right". The photo was the
    //              source and they agreed with it.
    //   edited     photo-first, they checked the card and changed a row or
    //              answered one the photo couldn't see. Any row they switched
    //              away from the photo is listed as a disagreement.
    //   diverted   photo-first, they said "Not quite". Their answers decided
    //              the routine, so every disagreement is listed.
    //   (other)    questions-first or the result-page re-offer, where the
    //              photo added things on its own. Disclosed as additions.
    var source = answers.photo_source || '';

    if (source === 'confirmed') {
      if (copy.confirmed_line) {
        parts.push('<p class="tss-findings__note">' + escapeHtml(copy.confirmed_line) + '</p>');
      }
    }

    if (source === 'diverted' || source === 'edited') {
      var conflicts = [];
      try {
        conflicts = (window.TSSQuizVision && window.TSSQuizVision.findConflicts)
          ? window.TSSQuizVision.findConflicts(read, answers) : [];
      } catch (e) { conflicts = []; }
      // On the check card, only rows they actually switched away from the
      // photo are disagreements. Rows the photo couldn't see never are.
      if (source === 'edited') {
        var edits = answers.photo_edits || [];
        conflicts = conflicts.filter(function (cf) { return edits.indexOf(cf.field) !== -1; });
      }

      var D = copy.differs || {};
      var words = D.skin_words || {};
      var lines = [];
      for (var ci = 0; ci < conflicts.length; ci++) {
        var cf = conflicts[ci];
        var text = '';
        if (cf.field === 'skin_type' && D.skin_type) {
          text = D.skin_type
            .replace('{photo}', words[cf.photo] || cf.photo)
            .replace(/\{theirs\}/g, words[cf.theirs] || cf.theirs);
        } else {
          text = D[cf.field + '_' + cf.photo] || '';
        }
        if (text) lines.push(text);
      }

      if (lines.length) {
        parts.push('<div class="tss-findings__differs">');
        parts.push('<strong class="tss-findings__differs-heading">' + escapeHtml(D.heading || '') + '</strong>');
        var lead = (source === 'edited' && D.lead_edited) ? D.lead_edited : (D.lead || '');
        parts.push('<p class="tss-findings__differs-lead">' + escapeHtml(lead) + '</p>');
        parts.push('<ul class="tss-findings__differs-list">');
        for (var li = 0; li < lines.length; li++) {
          parts.push('<li>' + escapeHtml(lines[li]) + '</li>');
        }
        parts.push('</ul></div>');
      } else if (source === 'edited' && copy.edited_line) {
        // They only filled in rows the photo couldn't see.
        parts.push('<p class="tss-findings__note">' + escapeHtml(copy.edited_line) + '</p>');
      } else if (copy.matched) {
        // They answered for themselves and it happened to line up.
        parts.push('<p class="tss-findings__note">' + escapeHtml(copy.matched) + '</p>');
      }
    }

    // What the photo changed, said out loud. Nothing here happens silently.
    // Only for the paths where the photo added things on its own. On the
    // confirmed path these are things the customer AGREED to, so calling them
    // things they "didn't mention" would be false.
    var addedLabels = [];
    if (source === 'confirmed' || source === 'diverted' || source === 'edited') changes = { added: [], removed: [], skin_type_set: null };
    for (var j = 0; j < (changes.added || []).length; j++) {
      var lbl = copy.added_label && copy.added_label[changes.added[j]];
      if (lbl) addedLabels.push(lbl);
    }
    if (addedLabels.length) {
      parts.push('<div class="tss-findings__added"><strong>' +
        escapeHtml(copy.added_intro || '') + '</strong> ' +
        escapeHtml(addedLabels.join('. ')) + '. ' +
        escapeHtml(copy.added_note || '') + '</div>');
    }

    if ((changes.removed || []).length) {
      // Two different situations read identically without this: marks left to
      // treat, versus nothing active left at all.
      var removedCopy = (changes.removal_outcome === 'maintenance' && copy.removed_line_clear)
        ? copy.removed_line_clear
        : copy.removed_line;
      if (removedCopy) {
        parts.push('<p class="tss-findings__note">' + escapeHtml(removedCopy) + '</p>');
      }
    }

    if (changes.skin_type_set && copy.skin_type_line) {
      parts.push('<p class="tss-findings__note">' +
        escapeHtml(copy.skin_type_line.replace('{type}', changes.skin_type_set)) +
        '</p>');
    }

    // Only claim a match when nothing was added or removed.
    if (!addedLabels.length && !(changes.removed || []).length &&
        read.agreement && read.agreement.matches_their_answers === 'agrees' &&
        copy.matched) {
      parts.push('<p class="tss-findings__note">' + escapeHtml(copy.matched) + '</p>');
    }

    if (read.refer_to_human && copy.refer) {
      parts.push(
        '<div class="tss-findings__refer">' +
          '<span class="tss-findings__refer-eyebrow">' + escapeHtml(copy.refer.eyebrow || '') + '</span>' +
          '<p class="tss-findings__refer-body">' + escapeHtml(copy.refer.body || '') + '</p>' +
        '</div>'
      );
    }

    parts.push('<p class="tss-findings__disclaimer">' + escapeHtml(copy.disclaimer || '') + '</p>');
    parts.push('</div>');

    host.innerHTML = parts.join('');
    host.hidden = false;

    track('findings_shown', {
      session_id: state && state.session_id,
      zone_count: zones.length,
      added: (changes.added || []).join(','),
      refer: !!read.refer_to_human
    });
  }

  // =========================================================================
  // Second offer, for people who skipped the photo in the quiz. They already
  // have their routine, so there is no funnel left to lose here.
  // On a successful read it recomputes the persona and reloads the page, so
  // the whole result page is rebuilt from one source of truth.
  // =========================================================================
  function renderPhotoReoffer(state) {
    var host = document.getElementById('tss-findings-reoffer');
    if (!host) return;

    var V = window.TSSQuizVision;
    var a = (state && state.answers) || {};
    var copy = (window.TSSQuizCopy && window.TSSQuizCopy.output &&
                window.TSSQuizCopy.output.findings &&
                window.TSSQuizCopy.output.findings.reoffer) || null;

    // Hide when vision is off, when a read already exists, or when the
    // browser cannot do the work.
    //
    // Also hidden for anyone who already tried and ran out of attempts. The
    // copy says "you skipped the photo earlier", which would be a lie to
    // someone who tried three times and got nowhere.
    var triedAndFailed = (a.photo_attempts || 0) > 0;
    if (!copy || !V || !V.isEnabled() || a.photo_read || triedAndFailed ||
        !window.fetch || !window.FileReader || !window.Promise) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }

    // Consent has to be collected here too. The in-quiz path gates on an
    // unbundled checkbox, and an upload from this card is the same processing
    // of the same data, so it needs the same gate.
    var qphoto = (window.TSSQuizCopy && window.TSSQuizCopy.questions &&
                  window.TSSQuizCopy.questions.photo) || {};

    host.innerHTML =
      '<span class="tss-findings__eyebrow">' + escapeHtml(copy.eyebrow || '') + '</span>' +
      '<h3 class="tss-findings__heading">' + escapeHtml(copy.heading || '') + '</h3>' +
      '<div class="tss-findings-reoffer__card">' +
        '<p class="tss-findings-reoffer__body">' + escapeHtml(copy.body || '') + '</p>' +
        '<label class="tss-photo__check">' +
          '<input type="checkbox" id="tss-reoffer-consent-0">' +
          '<span>' + escapeHtml(qphoto.consent_analyse || '') + '</span>' +
        '</label>' +
        '<label class="tss-photo__check">' +
          '<input type="checkbox" id="tss-reoffer-consent-1">' +
          '<span>' + escapeHtml(qphoto.consent_age || '') + '</span>' +
        '</label>' +
        '<input type="file" accept="image/*" capture="user" class="tss-findings-reoffer__file" id="tss-reoffer-file">' +
        '<button class="tss-btn" type="button" id="tss-reoffer-cta" disabled>' + escapeHtml(copy.cta || 'Add a photo') + '</button>' +
      '</div>';
    host.hidden = false;
    track('photo_reoffer_shown', { session_id: state && state.session_id });

    var input = document.getElementById('tss-reoffer-file');
    var cta = document.getElementById('tss-reoffer-cta');
    if (!input || !cta) return;

    var boxes = [
      document.getElementById('tss-reoffer-consent-0'),
      document.getElementById('tss-reoffer-consent-1')
    ];
    function refreshConsent() {
      var allChecked = true;
      for (var i = 0; i < boxes.length; i++) {
        if (!boxes[i] || !boxes[i].checked) allChecked = false;
      }
      cta.disabled = !allChecked;
    }
    for (var bi = 0; bi < boxes.length; bi++) {
      if (boxes[bi]) boxes[bi].addEventListener('change', refreshConsent);
    }
    refreshConsent();

    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      input.click();
    });

    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (!file) return;
      var original = cta.textContent;
      cta.disabled = true;
      cta.textContent = copy.reading || 'Reading your photo.';
      track('photo_reoffer_taken', { session_id: state && state.session_id });

      V.processFile(file).then(function (res) {
        if (!res.ok) {
          cta.disabled = false;
          cta.textContent = original;
          reofferError(host, res.reason);
          return null;
        }
        V.saveThumb(state.session_id, res.thumb);
        return V.analyse({
          b64: res.b64,
          mime: res.mime,
          answers: {
            skin_type: a.skin_type,
            concerns: a.concern_buckets,
            acne_freq: a.acne_freq,
            sensitivity: a.sensitivity
          }
        }).then(function (out) {
          if (!out.ok || !out.analysis || out.analysis.usable !== true) {
            cta.disabled = false;
            cta.textContent = original;
            reofferError(host, (out.analysis && out.analysis.reason) || 'fallback');
            return null;
          }
          applyReofferRead(state, out.analysis);
          return null;
        });
      })['catch'](function () {
        cta.disabled = false;
        cta.textContent = original;
        reofferError(host, 'fallback');
      });
    });
  }

  function reofferError(host, reason) {
    var retake = (window.TSSQuizCopy && window.TSSQuizCopy.questions &&
                  window.TSSQuizCopy.questions.photo &&
                  window.TSSQuizCopy.questions.photo.retake) || {};
    var msg = retake[reason] || retake.fallback || 'That one did not work. Try another photo.';
    var card = host.querySelector('.tss-findings-reoffer__card');
    if (!card) return;
    var existing = card.querySelector('.tss-findings__note');
    if (existing) { existing.textContent = msg; return; }
    var p = document.createElement('p');
    p.className = 'tss-findings__note';
    p.textContent = msg;
    card.appendChild(p);
  }

  // Writes the read into state, recomputes the routine, drops the stale AI
  // copy for this session, and reloads. Deliberately does NOT touch
  // state.completed or the completion cookie.
  function applyReofferRead(state, analysis) {
    var V = window.TSSQuizVision;
    try {
      state.answers.photo_read = analysis;
      state.answers.photo_usable = true;
      state.answers.photo_skipped = false;

      // CRITICAL. Without these two, "Edit my answers" sets completed=false,
      // and the quiz's resume logic then sees a photo_read with no reconcile
      // answer and drops the user straight into the reconcile question, where
      // answering it could strip a concern they never questioned. Mark the
      // photo step finished, because from here it is.
      state.answers.photo_done = true;
      state.answers.photo_reconcile = 'not_asked';

      // The reconcile question cannot be asked here, so the photo is held to
      // additions only. A removal always needs the user to confirm it.
      state.answers.vision_changes = V.applyFindings(analysis, state.answers, null);

      if (window.TSSQuizEngine && typeof window.TSSQuizEngine.compute === 'function') {
        state.persona = window.TSSQuizEngine.compute(state.answers);
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));

      // The cached AI copy describes the previous routine. Drop it so the
      // page regenerates against the new one.
      try {
        var kill = [];
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (k && k.indexOf('tss_ai_v1_') === 0) kill.push(k);
        }
        for (var j = 0; j < kill.length; j++) localStorage.removeItem(kill[j]);
      } catch (e) {}

      // Distinct name on purpose. track() here already sends its own gtag
      // event, so reusing 'findings_applied' (which the quiz also emits, via
      // emit(), which does not gtag) would double-count one of the two.
      track('findings_applied_reoffer', {
        session_id: state.session_id,
        added: (state.answers.vision_changes.added || []).join(',')
      });
    } catch (e) {
      console.error('[TSS Quiz] reoffer apply failed:', e);
      // Put the button back so they are not left looking at a dead control.
      var cta = document.getElementById('tss-reoffer-cta');
      if (cta) {
        cta.disabled = false;
        var c = (window.TSSQuizCopy && window.TSSQuizCopy.output &&
                 window.TSSQuizCopy.output.findings &&
                 window.TSSQuizCopy.output.findings.reoffer) || {};
        cta.textContent = c.cta || 'Add a photo';
      }
      return;
    }
    window.location.reload();
  }

  // =========================================================================
  // Timeline renderer: picks variant based on whether RCF is in the routine
  // =========================================================================
  function renderTimeline(persona) {
    var host = document.getElementById('tss-timeline');
    if (!host || !window.TSSQuizCopy || !window.TSSQuizCopy.output) return;
    var hasRCF = (persona.products || []).indexOf('RCF') !== -1;
    var data = hasRCF
      ? window.TSSQuizCopy.output.timeline_with_rcf
      : window.TSSQuizCopy.output.timeline_without_rcf;
    if (!Array.isArray(data)) return;
    host.innerHTML = data.map(function (row) {
      return '<div class="tss-timeline__week">' +
               '<div class="tss-timeline__wk">' + escapeHtml(row.week) + '</div>' +
               '<div class="tss-timeline__what">' + escapeHtml(row.what) + '</div>' +
             '</div>';
    }).join('');
  }

  // =========================================================================
  // FAQ renderer: skips items flagged when_rcf_only if RCF is not in the bundle
  // =========================================================================
  function renderFAQ(persona) {
    var host = document.getElementById('tss-faq');
    if (!host || !window.TSSQuizCopy || !window.TSSQuizCopy.output) return;
    var hasRCF = (persona.products || []).indexOf('RCF') !== -1;
    var items = (window.TSSQuizCopy.output.faq || []).filter(function (item) {
      if (item.when_rcf_only) return hasRCF;
      return true;
    });
    host.innerHTML = items.map(function (item) {
      return '<div class="tss-faq__item">' +
               '<button class="tss-faq__q" type="button">' + escapeHtml(item.q) + '</button>' +
               '<div class="tss-faq__a">' + escapeHtml(item.a) + '</div>' +
             '</div>';
    }).join('');
    host.querySelectorAll('.tss-faq__item').forEach(function (el) {
      var btn = el.querySelector('.tss-faq__q');
      if (btn) btn.onclick = function () { el.classList.toggle('tss-open'); };
    });
  }

  function humanize(code) {
    var map = {
      red_painful_pimples: 'Red painful pimples',
      pus_filled_acne: 'Pus-filled acne',
      large_cystic_pimples: 'Large/cystic',
      small_white_red_pimples: 'Small pimples',
      blackheads: 'Blackheads',
      whiteheads: 'Whiteheads',
      uneven_texture: 'Uneven texture',
      open_pores: 'Open pores',
      post_acne_marks: 'Post-acne marks',
      maintenance: 'Maintenance',
      irritated_sensitive: 'Irritated/sensitive',
      fungal_acne: 'Fungal acne',
      rosacea: 'Rosacea'
    };
    return map[code] || code;
  }
  function humanizeFreq(code) {
    var m = { almost_always: 'Almost always', every_now_then: 'Every now and then', once_a_month: 'Once a month', rarely: 'Rarely' };
    return m[code] || code;
  }

  function renderRoutine(id, steps, persona) {
    var container = document.getElementById(id);
    if (!container) return;
    container.innerHTML = '';
    if (!steps || !steps.length) {
      container.innerHTML = '<div style="padding:8px 0; color:#8a8a8a; font-size:13px;">–</div>';
      return;
    }
    var meta = window.TSSQuizEngine.productMeta;
    var relabelBsc = persona && persona.bsc_state && persona.bsc_state !== 'bundled';
    steps.forEach(function (code, i) {
      var row = document.createElement('div');
      row.className = 'tss-routine__step';
      var inner;
      if (code === 'BSC' && relabelBsc) {
        // BSC isn't a bundled product for this routine. Keep the step but show it
        // as a generic gentle cleanser, suggesting BSC in brackets.
        inner = '<strong>Gentle cleanser</strong> <span class="tss-routine__sugg">(Barrier Soothing Cleanser)</span>';
      } else {
        var prod = meta[code] || { name: code, short: code };
        inner = '<strong>' + prod.short + '</strong> · ' + prod.name;
      }
      row.innerHTML = '<div class="tss-routine__num">' + (i+1) + '</div><div>' + inner + '</div>';
      container.appendChild(row);
    });
  }

  // =========================================================================
  // Grouped products (Section 3). Splits the routine into treatment /
  // support / addon groups and renders each with a small label.
  // =========================================================================
  function fetchAndRenderGroupedProducts(persona, state, aiCopy) {
    var host = document.getElementById('tss-products-grouped');
    if (!host) return;

    var groups = (window.TSSQuizEngine && window.TSSQuizEngine.groupProducts)
      ? window.TSSQuizEngine.groupProducts(persona)
      : { treatment: [], support: persona.product_meta || [], addon: [] };

    // Skeleton while products fetch
    var count = (persona.product_meta || []).length || 4;
    var sk = '';
    for (var i = 0; i < count; i++) {
      sk += '<div class="tss-skeleton">' +
              '<div class="tss-skeleton__top"><div class="tss-skeleton__img"></div><div class="tss-skeleton__lines"><div class="tss-skeleton__row"></div><div class="tss-skeleton__row"></div></div></div>' +
              '<div class="tss-skeleton__row tss-skeleton__why"></div>' +
            '</div>';
    }
    host.innerHTML = sk;

    var products = persona.product_meta || [];
    var promises = products.map(function (p) {
      return fetch('/products/' + p.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) { return { meta: p, data: json }; })
        .catch(function () { return { meta: p, data: null }; });
    });

    Promise.all(promises).then(function (results) {
      // Index by code so we can build cards in group order
      var byCode = {};
      results.forEach(function (r) { byCode[r.meta.code] = r; });

      host.innerHTML = '';
      var itemPrices = [];
      var cartPayload = [];
      var soldOutCodes = [];
      var groupCopy = (window.TSSQuizCopy && window.TSSQuizCopy.output && window.TSSQuizCopy.output.product_groups) || {};

      ['treatment', 'support'].forEach(function (groupKey) {
        var groupMembers = groups[groupKey] || [];
        if (!groupMembers.length) return;

        var groupEl = document.createElement('div');
        groupEl.className = 'tss-prod-group tss-prod-group--' + groupKey;

        var label = groupCopy[groupKey] || '';
        if (label) {
          groupEl.innerHTML = '<div class="tss-prod-group__label">' + escapeHtml(label) + '</div>';
        }

        groupMembers.forEach(function (meta) {
          var r = byCode[meta.code];
          if (!r) return;
          if (!r.data) {
            groupEl.appendChild(buildMissingCard(meta));
            return;
          }
          var v0 = r.data.variants && r.data.variants[0];
          var soldOut = isSoldOut(v0);
          var card = buildProductCard(meta, r.data, persona, state, aiCopy, soldOut);
          groupEl.appendChild(card);

          // Sold out: shown, but never added to the cart or counted in the price.
          if (soldOut) {
            soldOutCodes.push(meta.code);
          } else if (v0) {
            var priceValue = parseFloat(v0.price) || 0;
            itemPrices.push(priceValue);
            cartPayload.push({ id: v0.id, quantity: 1 });
          }
        });

        host.appendChild(groupEl);
      });

      // Bundle-aware pricing
      var breakdown = calculateBundledTotal(itemPrices);
      renderStickyPrice(breakdown);
      var hasRCF = (persona.product_meta || []).some(function (p) { return p.code === 'RCF'; });
      renderStickyNote(hasRCF);

      var addAllBtn = document.getElementById('tss-add-all');
      var stickyBtn = document.getElementById('tss-sticky-cta');
      if (addAllBtn) addAllBtn.onclick = function () { addAllToCart(cartPayload, addAllBtn, state); };
      if (stickyBtn) stickyBtn.onclick = function () { addAllToCart(cartPayload, stickyBtn, state); };

      if (soldOutCodes.length) {
        // Say plainly that the full-routine button now adds the rest.
        if (addAllBtn) addAllBtn.textContent = 'Add in-stock products to cart';
        // Nothing left to buy: the bundle buttons would add an empty cart.
        if (!cartPayload.length) {
          if (addAllBtn) addAllBtn.disabled = true;
          if (stickyBtn) stickyBtn.disabled = true;
        }
        track('products_sold_out_shown', {
          session_id: state && state.session_id,
          persona_id: persona && persona.persona_id,
          codes: soldOutCodes.join(',')
        });
      }

      // EMC add-on, rendered if not part of the bundled routine
      var routineHasEMC = (persona.product_meta || []).some(function (p) { return p.code === 'EMC'; });
      if (!routineHasEMC) renderEmcAddon(state);

      // BSC optional add-on (gentle cleanser). Shown when the engine flagged it:
      // routine has no other cleanser, or skin is "a bit" sensitive.
      if (persona.bsc_optional) renderBscAddon(state, persona);

      // Rebrand Judge.me "reviews" → "solved stories" across all rendered cards
      rebrandJudgemeText(host);
    });
  }

  // =========================================================================
  // EMC standalone add-on card, rendered outside the bundle.
  // =========================================================================
  function renderEmcAddon(state) {
    var host = document.getElementById('tss-emc-addon');
    if (!host || !window.TSSQuizCopy || !window.TSSQuizCopy.output || !window.TSSQuizCopy.output.emc_addon) return;
    var copy = window.TSSQuizCopy.output.emc_addon;
    var handle = 'effortless-melting-cleanser';

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants || !data.variants.length) return;
        var variant = data.variants[0];
        if (isSoldOut(variant)) return;   // optional extra: don't offer it sold out
        var img = data.featured_image || (data.images && data.images[0]) || '';
        var badgeHtml = getBadgeHtmlForHandle(handle);
        var badgeBlock = badgeHtml
          ? '<div class="tss-prod__badge"><div class="jdgm-widget jdgm-preview-badge" data-id="' + (data.id || '') + '">' + badgeHtml + '</div></div>'
          : '';

        host.hidden = false;
        track('emc_addon_shown', { session_id: state && state.session_id });
        host.innerHTML = '' +
          '<div class="tss-emc-addon__eyebrow">' + escapeHtml(copy.eyebrow) + '</div>' +
          '<h3 class="tss-emc-addon__heading">' + escapeHtml(copy.heading) + '</h3>' +
          '<div class="tss-emc-addon__card">' +
            '<div class="tss-prod__top">' +
              '<img class="tss-prod__img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(data.title) + '" loading="lazy"/>' +
              '<div class="tss-prod__info">' +
                '<div class="tss-prod__name">' + escapeHtml(data.title) + '</div>' +
                badgeBlock +
                '<div class="tss-prod__price">' + formatMoney(variant.price) + '</div>' +
              '</div>' +
            '</div>' +
            '<div class="tss-emc-addon__body">' + escapeHtml(copy.body) + '</div>' +
            '<div class="tss-prod__actions">' +
              '<a href="/products/' + escapeHtml(handle) + '" class="tss-prod__details">Full details →</a>' +
              '<button class="tss-btn tss-btn--secondary tss-atc" data-variant-id="' + variant.id + '">' + escapeHtml(copy.cta_add) + '</button>' +
            '</div>' +
          '</div>';

        rebrandJudgemeText(host);

        var btn = host.querySelector('.tss-atc');
        if (btn) btn.addEventListener('click', function () {
          addSingleToCart(btn.getAttribute('data-variant-id'), btn, 'EMC', state, null);
          track('emc_addon_added', { session_id: state && state.session_id });
        });
      })
      .catch(function () { /* leave hidden if product unavailable */ });
  }

  // =========================================================================
  // BSC standalone add-on card (gentle cleanser), rendered outside the bundle.
  // Mirrors renderEmcAddon. Shown when persona.bsc_optional is set: the routine
  // has no other cleanser, or the user is "a bit" sensitive (Q6).
  // =========================================================================
  function renderBscAddon(state, persona) {
    var host = document.getElementById('tss-bsc-addon');
    if (!host || !window.TSSQuizCopy || !window.TSSQuizCopy.output || !window.TSSQuizCopy.output.bsc_addon) return;
    var copy = window.TSSQuizCopy.output.bsc_addon;
    var handle = 'barrier-soothing-cleanser';

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants || !data.variants.length) return;
        var variant = data.variants[0];
        if (isSoldOut(variant)) return;   // optional extra: don't offer it sold out
        var img = data.featured_image || (data.images && data.images[0]) || '';
        var badgeHtml = getBadgeHtmlForHandle(handle);
        var badgeBlock = badgeHtml
          ? '<div class="tss-prod__badge"><div class="jdgm-widget jdgm-preview-badge" data-id="' + (data.id || '') + '">' + badgeHtml + '</div></div>'
          : '';

        host.hidden = false;
        track('bsc_addon_shown', { session_id: state && state.session_id });
        host.innerHTML = '' +
          '<div class="tss-emc-addon__eyebrow">' + escapeHtml(copy.eyebrow) + '</div>' +
          '<h3 class="tss-emc-addon__heading">' + escapeHtml(copy.heading) + '</h3>' +
          '<div class="tss-emc-addon__card">' +
            '<div class="tss-prod__top">' +
              '<img class="tss-prod__img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(data.title) + '" loading="lazy"/>' +
              '<div class="tss-prod__info">' +
                '<div class="tss-prod__name">' + escapeHtml(data.title) + '</div>' +
                badgeBlock +
                '<div class="tss-prod__price">' + formatMoney(variant.price) + '</div>' +
              '</div>' +
            '</div>' +
            '<div class="tss-emc-addon__body">' + escapeHtml(copy.body) + '</div>' +
            '<div class="tss-prod__actions">' +
              '<a href="/products/' + escapeHtml(handle) + '" class="tss-prod__details">Full details →</a>' +
              '<button class="tss-btn tss-btn--secondary tss-atc" data-variant-id="' + variant.id + '">' + escapeHtml(copy.cta_add) + '</button>' +
            '</div>' +
          '</div>';

        rebrandJudgemeText(host);

        var btn = host.querySelector('.tss-atc');
        if (btn) btn.addEventListener('click', function () {
          addSingleToCart(btn.getAttribute('data-variant-id'), btn, 'BSC', state, null);
          track('bsc_addon_added', { session_id: state && state.session_id });
        });
      })
      .catch(function () { /* leave hidden if product unavailable */ });
  }

  // Rebrand Judge.me's review count to "solved stories" within our PDP section only.
  // Reads the review count from the reliable `data-number-of-reviews` attribute
  // (always set by Judge.me on the badge wrapper) and synthesizes our branded text.
  // Creates the text element if Judge.me's account settings suppressed it.
  // Scoped to rootEl so a Judge.me section the merchant adds below stays untouched.
  function rebrandJudgemeText(rootEl) {
    if (!rootEl || !rootEl.querySelectorAll) return;
    var badges = rootEl.querySelectorAll('.jdgm-prev-badge, .jdgm-preview-badge');
    badges.forEach(function (badge) {
      var count = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      var text;
      if (!count || count < 1) text = 'No stories yet';
      else if (count === 1)    text = '1 solved story';
      else                     text = count + ' solved stories';

      var textEl = badge.querySelector('.jdgm-prev-badge__text, .jdgm-preview-badge__text');
      if (!textEl) {
        textEl = document.createElement('span');
        textEl.className = 'jdgm-prev-badge__text';
        badge.appendChild(textEl);
      }
      textEl.textContent = text;
      // Force visible in case Judge.me's settings or inline styles hide it
      textEl.style.display = 'inline-block';
    });
  }

  // Pull a product's Judge.me badge HTML from the SSR container (server-rendered in Liquid).
  // Returns '' if that product has no badge written by Judge.me yet.
  function getBadgeHtmlForHandle(handle) {
    var el = document.querySelector('#tss-badges-ssr [data-tss-badge-handle="' + cssEscape(handle) + '"]');
    var html = el ? el.innerHTML.trim() : '';
    return html;
  }

  // Minimal CSS attribute-value escaper, handles the chars we'd reasonably see in handles.
  function cssEscape(s) { return String(s).replace(/"/g, '\\"'); }

  // SOLD OUT. window.TSSQuizSoldOut is printed by sections/tss-quiz-result
  // .liquid from the custom.is_sold_out variant metafield. The routine is
  // never changed for it: a sold-out product keeps its card and gets a
  // disabled "Sold out" button, and it is left out of the bundle cart and
  // price. Same look as the product pages.
  function isSoldOut(variant) {
    var list = window.TSSQuizSoldOut || [];
    if (!variant || !list.length) return false;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i]) === String(variant.id)) return true;
    }
    return false;
  }

  function buildProductCard(meta, data, persona, state, aiCopy, soldOut) {
    var card = document.createElement('div');
    card.className = 'tss-prod' + (soldOut ? ' tss-prod--soldout' : '');
    var img = (data.featured_image || (data.images && data.images[0])) || '';
    var price = (data.variants && data.variants[0] && data.variants[0].price) ? data.variants[0].price : data.price;
    var compareAt = (data.variants && data.variants[0] && data.variants[0].compare_at_price) ? data.variants[0].compare_at_price : null;

    // Prefer AI-generated copy; fall back to templates. AI copy is looked up
    // by product code — matches how the backend returns the JSON shape.
    var aiProd = (aiCopy && aiCopy.products && aiCopy.products[meta.code]) || null;
    var whyShortText = (aiProd && aiProd.short) ? aiProd.short : buildWhyShort(meta.code, persona);
    var whyDeepText  = (aiProd && aiProd.deep)  ? aiProd.deep  : buildWhy(meta.code, persona);

    // Small job tag above the card name, e.g. "For clearing breakouts"
    var jobForCode = (window.TSSQuizEngine && window.TSSQuizEngine.jobForProduct)
      ? window.TSSQuizEngine.jobForProduct(meta.code, persona)
      : null;
    var jobTagBlock = (jobForCode && jobForCode.label)
      ? '<div class="tss-prod__jobtag"><span class="tss-prod__jobtag-dot" style="background:' + escapeHtml(jobForCode.dot) + ';"></span>' + escapeHtml(jobForCode.label) + '</div>'
      : '';

    // Judge.me badge HTML, pulled from the SSR container
    var badgeHtml = getBadgeHtmlForHandle(meta.handle);
    var badgeBlock = badgeHtml
      ? '<div class="tss-prod__badge"><div class="jdgm-widget jdgm-preview-badge" data-id="' + (data.id || '') + '">' + badgeHtml + '</div></div>'
      : '';

    var whyShortBlock = whyShortText
      ? '<div class="tss-prod__why">' + escapeHtml(whyShortText) + '</div>'
      : '';
    var whyDeepBlock = whyDeepText
      ? '<details class="tss-prod__whymore">' +
          '<summary>How it works <span class="tss-prod__whymore-caret" aria-hidden="true">↓</span></summary>' +
          '<div class="tss-prod__whymore-body">' + escapeHtml(whyDeepText) + '</div>' +
        '</details>'
      : '';

    card.innerHTML = '' +
      jobTagBlock +
      '<div class="tss-prod__top">' +
        '<img class="tss-prod__img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(data.title || meta.name) + '" loading="lazy"/>' +
        '<div class="tss-prod__info">' +
          '<div class="tss-prod__name">' + escapeHtml(data.title || meta.name) + '</div>' +
          badgeBlock +
          '<div class="tss-prod__price">' +
            (compareAt && compareAt > price ? '<span class="tss-prod__original">' + formatMoney(compareAt) + '</span>' : '') +
            formatMoney(price) +
          '</div>' +
        '</div>' +
      '</div>' +
      whyShortBlock +
      whyDeepBlock +
      '<div class="tss-prod__actions">' +
        '<a href="/products/' + escapeHtml(meta.handle) + '" class="tss-prod__details">Full details →</a>' +
        (soldOut
          ? '<button class="tss-btn tss-btn--secondary tss-prod__soldout" type="button" disabled>Sold out</button>'
          : '<button class="tss-btn tss-btn--secondary tss-atc" data-variant-id="' + (data.variants && data.variants[0] ? data.variants[0].id : '') + '">Add to cart</button>') +
      '</div>';

    // Track expand/collapse on the deep WHY, feeds future engagement dashboards
    var details = card.querySelector('.tss-prod__whymore');
    if (details) {
      details.addEventListener('toggle', function () {
        track(details.open ? 'product_why_expanded' : 'product_why_collapsed', {
          code: meta.code,
          session_id: state && state.session_id,
          persona_id: persona && persona.persona_id
        });
      });
    }

    var btn = card.querySelector('.tss-atc');
    if (btn) btn.addEventListener('click', function () {
      addSingleToCart(btn.getAttribute('data-variant-id'), btn, meta.code, state, persona);
    });

    return card;
  }

  function buildMissingCard(meta) {
    var card = document.createElement('div');
    card.className = 'tss-prod';
    card.innerHTML = '<div class="tss-prod__info"><div class="tss-prod__name">' + escapeHtml(meta.name) + '</div><div style="color:#8a8a8a; font-size:13px;">Temporarily unavailable, check back soon.</div></div>';
    return card;
  }

  // Prefer the copy file's WHY (TSSQuizCopy.why), fall back to engine's copy if unavailable.
  function getWhySource(code) {
    if (window.TSSQuizCopy && window.TSSQuizCopy.why && window.TSSQuizCopy.why[code]) {
      return window.TSSQuizCopy.why[code];
    }
    if (window.TSSQuizEngine && window.TSSQuizEngine.why && window.TSSQuizEngine.why[code]) {
      return window.TSSQuizEngine.why[code];
    }
    return null;
  }

  // Short WHY: 1-2 lines above the collapsible. Same context-picking logic as buildWhy,
  // but reads from TSSQuizCopy.why_short. Silently returns '' if no short copy exists,
  // in which case the card just shows the deep WHY.
  function buildWhyShort(code, persona) {
    if (!window.TSSQuizCopy || !window.TSSQuizCopy.why_short) return '';
    var ws = window.TSSQuizCopy.why_short[code];
    if (!ws) return '';
    var key = pickWhyKey(code, persona);
    return ws[key] || ws.default || '';
  }

  // Extracted key-picking logic so short and deep WHY stay in lock-step.
  function pickWhyKey(code, persona) {
    var concerns = persona.why_concerns || [];
    var buckets = persona.buckets || {};
    if (code === 'RCF') {
      if (persona.skin === 'dry') return 'dry';
      if (concerns.indexOf('marks') !== -1 && concerns.indexOf('active_acne') !== -1) return 'marks';
      if (concerns.indexOf('active_acne') === -1) return 'spot';
      return 'active_acne';
    }
    if (code === 'BSC') {
      if (buckets.irritation) return 'irritation';
      if (buckets.active_acne || buckets.marks || buckets.texture) return 'pair';
      return 'daily';
    }
    if (code === 'USDC') {
      if (persona.skin === 'dry') return 'texture_dry';
      if (concerns.indexOf('texture') !== -1) return 'texture';
      return 'maintenance';
    }
    if (code === 'SFARS') {
      if (buckets.fungal_acne || buckets.rosacea) return 'fungal_rosacea';
      if (concerns.indexOf('active_acne') !== -1 && concerns.indexOf('marks') !== -1) return 'active_acne';
      return 'marks';
    }
    if (code === 'SS') {
      if (buckets.irritation || buckets.rosacea) return 'sensitive';
      if (buckets.marks) return 'marks';
      if (buckets.active_acne || buckets.texture || buckets.fungal_acne) return 'active_use';
      return 'default';
    }
    return 'default';
  }

  function buildWhy(code, persona) {
    var why = getWhySource(code);
    if (!why) return '';
    var concerns = persona.why_concerns || [];
    var buckets = persona.buckets || {};
    var products = persona.products || [];

    if (code === 'RCF') {
      if (persona.skin === 'dry') return why.dry;
      if (concerns.indexOf('marks') !== -1 && concerns.indexOf('active_acne') !== -1) return why.marks;
      if (concerns.indexOf('active_acne') === -1) return why.spot;
      return why.active_acne;
    }
    if (code === 'BSC') {
      if (buckets.irritation) return why.irritation;
      if (buckets.active_acne || buckets.marks || buckets.texture) return why.pair;
      return why.daily;
    }
    if (code === 'USDC') {
      if (persona.skin === 'dry') return why.texture_dry;
      if (concerns.indexOf('texture') !== -1) return why.texture;
      return why.maintenance;
    }
    if (code === 'SFARS') {
      if (buckets.fungal_acne || buckets.rosacea) return why.fungal_rosacea;
      if (concerns.indexOf('active_acne') !== -1 && concerns.indexOf('marks') !== -1) return why.active_acne;
      return why.marks;
    }
    // Sunscreen: pick an isolated variant (no other-product mentions) based on user's buckets/skin.
    if (code === 'SS') {
      if (buckets.irritation || buckets.rosacea) return why.sensitive || why.default || '';
      if (buckets.marks) return why.marks || why.default || '';
      if (buckets.active_acne || buckets.texture || buckets.fungal_acne) return why.active_use || why.default || '';
      return why.default || '';
    }
    if (code === 'BRGM' || code === 'BRIM' || code === 'EMC') return why.default;
    return '';
  }

  function cartStore(name) {
    try {
      return window.Alpine && Alpine.store ? Alpine.store(name) : null;
    } catch (e) {
      return null;
    }
  }

  // Section ids the theme wants re-rendered after a cart mutation.
  function cartSectionsToRender() {
    var helper = cartStore('xCartHelper');
    return helper && typeof helper.getSectionsToRender === 'function'
      ? helper.getSectionsToRender()
      : [];
  }

  // Swap in the freshly rendered cart sections, resync the cart count, then let
  // the rest of the theme know the cart changed. Mirrors the global handler.
  function syncCartUI(response) {
    var sectionsToRender = cartSectionsToRender();
    if (response && response.sections && sectionsToRender.length && typeof getSectionInnerHTML === 'function') {
      sectionsToRender.forEach(function (section) {
        var el = document.querySelector(section.selector);
        if (el && response.sections[section.id]) {
          el.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
        }
      });
    }

    var helper = cartStore('xCartHelper');
    var bubble = document.querySelector('#cart-icon-bubble span');
    if (helper && bubble) {
      helper.currentItemCount = parseInt(bubble.innerHTML, 10) || 0;
    }

    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));

    if (window.trackMetaAddToCart) {
      try { window.trackMetaAddToCart(response); } catch (e) {}
    }
  }
 
  function openCartDrawer() {
    var popup = cartStore('xPopup');
    if (popup && typeof popup.close === 'function') {
      try { popup.close(); } catch (e) {}
    }
    var miniCart = cartStore('xMiniCart');
    if (miniCart && typeof miniCart.openCart === 'function') {
      miniCart.openCart();
    }
    return false;
  }

  function postCartAdd(payload) {
    var sections = cartSectionsToRender().map(function (s) { return s.id; });
    var body = {
      sections: sections.length ? sections : undefined,
      sections_url: window.location.pathname
    };
    for (var key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) body[key] = payload[key];
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status === 422 || (data.message && !data.items && !data.id)) {
          throw new Error(data.description || data.message || 'Cart error');
        }
        return data;
      });
    });
  }

  function addAllToCart(items, btn, state) {
    if (!items || !items.length) return;
    // innerHTML, not textContent: the sticky button holds the two-price
    // layout, and restoring plain text after a failed add flattened it into
    // one jumbled line.
    var orig = btn.innerHTML;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    postCartAdd({ items: items }).then(function (response) {
      btn.textContent = '✓ Added, opening cart';
      track('add_to_cart_full_routine', {
        session_id: state && state.session_id,
        persona_id: state && state.persona && state.persona.persona_id,
        item_count: items.length,
        variant_ids: items.map(function (x) { return x.id; })
      });
      syncCartUI(response);
      // Give the button's "Added" state a moment to register, then open cart.
      setTimeout(function () { openCartDrawer(); }, 600);
    }).catch(function () {
      btn.innerHTML = orig; btn.disabled = false;
      alert('Sorry, one of the products couldn\'t be added. Please try the individual Add to cart buttons.');
    });
  }

  function addSingleToCart(variantId, btn, code, state, persona) {
    if (!variantId) return;
    var orig = btn.textContent;
    btn.textContent = 'Adding…'; btn.disabled = true;
    postCartAdd({ items: [{ id: variantId, quantity: 1 }] })
      .then(function (response) {
        btn.textContent = '✓ Added';
        track('add_to_cart_single', {
          session_id: state && state.session_id,
          persona_id: (persona && persona.persona_id) || (state && state.persona && state.persona.persona_id),
          code: code || null,
          variant_id: variantId
        });
        syncCartUI(response);
        openCartDrawer();
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1500);
      }).catch(function () {
        btn.textContent = 'Try again'; btn.disabled = false;
      });
  }

  function formatMoney(cents) {
    var v = parseFloat(cents) / 100;
    if (isNaN(v)) return '';
    // Shopify stores amounts as cents. Currency symbol left generic, theme will handle most cases.
    var locale = window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en-IN';
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'INR';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, maximumFractionDigits: 0 }).format(v);
    } catch (e) {
      return '₹' + Math.round(v);
    }
  }

  function escapeHtml(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // =========================================================================
  // DISCOUNT CALCULATOR
  //
  // Current offer:
  //   - 15% off when retail total >= ₹799
  //   - 20% off when retail total >= ₹1,299 (replaces 15%, best rate wins)
  //   - Below ₹799: no discount, full retail
  //   - Free gift on orders above ₹999 — handled automatically by Shopflo
  //     at checkout, no quiz-side display needed.
  //
  // ⚠️ WHEN THE PROMO CHANGES: edit DISCOUNT_TIERS below, or set
  // DISCOUNT_ENABLED = false to show plain retail totals.
  // Tiers are checked top-to-bottom; first match wins.
  // Thresholds are in paise (₹1,299 = 129900). Retail = sum of product prices
  // before any discount.
  // =========================================================================
  var DISCOUNT_ENABLED = true;
  var DISCOUNT_TIERS = [
    { min_retail: 129900, rate: 0.20 },  // retail >= ₹1,299 → 20% off
    { min_retail: 79900,  rate: 0.15 },  // retail >= ₹799   → 15% off
    { min_retail: 0,      rate: 0 },     // below ₹799       → no discount
  ];

  // Additional quiz-taker coupon, stacked ON TOP of the website discount above.
  // NEW-CUSTOMERS-ONLY: shown as a secondary "Get it at ₹X with SOLVED10 / for
  // new customers" callout, never baked into the headline price. Display-only;
  // the customer must enter the code at checkout for it to actually apply (and
  // Shopflo enforces the new-customer eligibility). Set enabled:false to remove.
  var SOLVED10 = { enabled: true, rate: 0.10, code: 'SOLVED10' };

  // Holds the support/SOLVED10 rotation interval so we never stack two.
  var stickyRotateTimer = null;

  // BUY 2 GET 1 FREE, until the end of 2 Oct 2026 (IST). While it runs it
  // REPLACES the tiers above; after the end date the tiers come back on their
  // own, no upload needed. Mirrors the Shopflo auto-applied coupons "Buy 2 Get
  // 1" / "Buy 4 Get 2" / "Buy 9 Get 3" on the Non Combos collection (all eight
  // quiz products are in it): every 3 items, 1 free. The free one is taken as
  // the cheapest, so the quiz never shows a lower price than checkout.
  // SOLVED10 still stacks on top (Shopflo: combinable with all discounts).
  // To stop it early, set enabled: false.
  var B2G1 = { enabled: true, ends: Date.UTC(2026, 9, 2, 18, 30, 0) };  // 3 Oct 00:00 IST

  function b2g1Active() {
    return B2G1.enabled && Date.now() < B2G1.ends;
  }

  // ANY 3 FOR ₹1,299 (from 13 Oct 2026, no end date set). Mirrors the Shopflo
  // auto-applied "Bundle" coupon on the "Pick any 3" collection (all eight
  // quiz products are in it): each set of 3 costs ₹1,299, up to 3 sets, so 6
  // items are ₹2,598. While on, it REPLACES the tiers and B2G1 below.
  // Leftover items (the 4th, 5th) are charged in full. `pick` says which items
  // go in the sets:
  //   'cheapest'  safe default, the quiz can never show less than checkout
  //   'priciest'  use this once a real 4-5 item cart at Shopflo checkout shows
  //               the expensive items bundled (much bigger saving)
  // SOLVED10 still stacks on top. To stop the offer, set enabled: false.
  var BUNDLE3 = { enabled: true, size: 3, price: 129900, maxSets: 3, pick: 'priciest' };   // paise

  function calculateBundledTotal(prices) {
    var subtotal = prices.reduce(function (s, p) { return s + p; }, 0);
    // Under 3 items there is no offer at all while the bundle runs (the old
    // tiers are switched off in Shopflo), so show plain retail.
    if (BUNDLE3.enabled && prices.length < BUNDLE3.size) {
      return { subtotal: subtotal, total: subtotal, savings: 0, bundled: false };
    }
    if (BUNDLE3.enabled) {
      var sets = Math.min(Math.floor(prices.length / BUNDLE3.size), BUNDLE3.maxSets);
      var asc = prices.slice().sort(function (x, y) {
        return BUNDLE3.pick === 'priciest' ? y - x : x - y;
      });
      var saved = 0;
      for (var g = 0; g < sets; g++) {
        var setSum = 0;
        for (var k = 0; k < BUNDLE3.size; k++) setSum += asc[g * BUNDLE3.size + k];
        if (setSum > BUNDLE3.price) saved += setSum - BUNDLE3.price;
      }
      return { subtotal: subtotal, total: subtotal - saved, savings: saved, bundled: saved > 0 };
    }
    if (b2g1Active() && prices.length) {
      var free = Math.floor(prices.length / 3);
      var cheapestFirst = prices.slice().sort(function (x, y) { return x - y; });
      var saved = 0;
      for (var f = 0; f < free; f++) saved += cheapestFirst[f];
      return { subtotal: subtotal, total: subtotal - saved, savings: saved, bundled: saved > 0 };
    }
    if (!DISCOUNT_ENABLED || prices.length === 0) {
      return { subtotal: subtotal, total: subtotal, savings: 0, bundled: false };
    }
    // First matching tier (highest threshold first) wins
    var rate = 0;
    for (var i = 0; i < DISCOUNT_TIERS.length; i++) {
      if (subtotal >= DISCOUNT_TIERS[i].min_retail) { rate = DISCOUNT_TIERS[i].rate; break; }
    }
    if (!rate) {
      return { subtotal: subtotal, total: subtotal, savings: 0, bundled: false };
    }
    var savings = Math.round(subtotal * rate);
    var total   = subtotal - savings;
    return { subtotal: subtotal, total: total, savings: savings, bundled: true };
  }

  function renderStickyPrice(breakdown) {
    var priceEl = document.getElementById('tss-sticky-price');
    if (!priceEl) return;
    // SOLVED10 is now NEW-CUSTOMERS-ONLY, so the headline price everyone sees is
    // breakdown.total (website discount only, no coupon baked in). The SOLVED10
    // price is shown as a secondary "Get it at ₹X with SOLVED10 / for new
    // customers" callout beside it, so we never imply returning customers get it.
    var defaultPrice = breakdown.total;
    if (SOLVED10.enabled) {
      var solvedPrice = Math.round(breakdown.total * (1 - SOLVED10.rate));
      priceEl.innerHTML =
        '<span class="tss-sticky__cta-main">' + formatMoney(defaultPrice) + '</span>' +
        '<span class="tss-sticky__cta-offer">' +
          '<span class="tss-sticky__cta-offer-main">Get it at ' +
            '<span class="tss-sticky__cta-offer-price">' + formatMoney(solvedPrice) + '</span>' +
            ' with ' + SOLVED10.code + '</span>' +
          '<span class="tss-sticky__cta-offer-sub">for new customers</span>' +
        '</span>';
    } else {
      priceEl.innerHTML = '<span class="tss-sticky__cta-main">' + formatMoney(defaultPrice) + '</span>';
    }
  }

  // Icons for the rotating note bar.
  var STICKY_SUPPORT_ICON = '<svg class="tss-sticky__support-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3a8 8 0 0 0-8 8v5a3 3 0 0 0 3 3h1v-7H5v-1a7 7 0 0 1 14 0v1h-3v7h1a3 3 0 0 0 3-3v-5a8 8 0 0 0-8-8Z" fill="currentColor"/></svg>';
  var STICKY_TAG_ICON = '<svg class="tss-sticky__support-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20.6 13.4 11 3.8A2 2 0 0 0 9.6 3H4a1 1 0 0 0-1 1v5.6A2 2 0 0 0 3.6 11l9.6 9.6a2 2 0 0 0 2.8 0l4.6-4.6a2 2 0 0 0 0-2.8Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="7.5" cy="7.5" r="1.4" fill="currentColor"/></svg>';

  // Note bar above the sticky CTA. Rotates between messages every 3s.
  //   - SOLVED10 coupon line: shown to everyone (the coupon applies to all).
  //   - Post-delivery support line: RCF-gated (WhatsApp support is RCF-only).
  // With RCF, both lines rotate. Without RCF, only the SOLVED10 line shows
  // (static, nothing to rotate).
  function renderStickyNote(showIfRCF) {
    var el = document.getElementById('tss-sticky-support');
    var inner = document.getElementById('tss-sticky-support-inner');
    if (!el || !inner) return;

    var msgs = [];
    if (showIfRCF) {
      msgs.push(STICKY_SUPPORT_ICON + '<span>POST-DELIVERY SUPPORT INCLUDED</span>');
    }
    if (SOLVED10.enabled) {
      msgs.push(STICKY_TAG_ICON + '<span>New customers: use ' + SOLVED10.code + ' for an extra 10% off</span>');
    }

    if (stickyRotateTimer) { clearInterval(stickyRotateTimer); stickyRotateTimer = null; }
    if (!msgs.length) { el.setAttribute('hidden', ''); return; }

    el.removeAttribute('hidden');
    var i = 0;
    inner.innerHTML = msgs[0];
    if (msgs.length < 2) return; // single message, no rotation needed

    stickyRotateTimer = setInterval(function () {
      inner.style.opacity = '0';
      setTimeout(function () {
        i = (i + 1) % msgs.length;
        inner.innerHTML = msgs[i];
        inner.style.opacity = '1';
      }, 300); // match the CSS opacity transition
    }, 3000);
  }
})();
